import React from "react";
import { Box } from "@mui/material";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface LayoutProps {
  data: {
    name: string;
    occupation: string;
  }; // Update the type of 'data' according to your requirements
}

const UnProtectedLayout: React.FC<LayoutProps> = ({ data }) => {
  // Use AuthContext as the source of truth
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    // Let the root route handle the redirect based on permissions
    // This prevents race condition where user is redirected before permissions are loaded
    return <Navigate to="/" replace />;
  }

  return (
    <Box className="unprotected-pages">
      <Outlet />
    </Box>
  );
};

export default UnProtectedLayout;
